module.exports = __webpack_public_path__ + "img/f13f31a.png";